<script>
import bem from '@/utils/bem';
import toggleModal from '@/mixins/toggleModal';
import UploadImages from '@/components/ux/upload/Upload-images.vue';
import { mapActions } from 'vuex';
import { UploadOutlined } from '@ant-design/icons-vue';
import URLS from '@/store/urls';
import apiCall from '@/store/apiCall';
import notificationWithIcon from '@/utils/notification';

const b = bem('change-wizard-card-modal');
export default {
  data() {
    return {
      cardHelpCenterList: [],
      productList: [],
      files: [],
      mobileFiles: [],
      videoUrl: '',
      showFirst: 'images',
    };
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isNewCard: {
      type: Boolean,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
    helpCenterList: {
      type: Array,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    stepId: Number,
    withToggle: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UploadImages,
    UploadOutlined,
  },
  mixins: [toggleModal],
  mounted() {
    if (this.helpCenterList.length) {
      this.cardHelpCenterList = this.helpCenterList.reduce((acc, item) => {
        if (item.isCategory) {
          return [
            ...acc,
            ...item.helpCenters.map((elem) => ({ label: elem.title, value: elem.id })),
          ];
        }
        return [
          ...acc,
          { label: item.title, value: item.id },
        ];
      }, []);
    }
    if (this.products.length) {
      this.productList = this.products.map((item) => ({ label: item.displayName, value: item.id }));
    }
    if (this.section) {
      this.videoUrl = this.section.videoUrl || '';
      this.showFirst = this.section.showFirst || 'images';
    }
  },
  methods: {
    ...mapActions({
      updateWizardCardAction: 'wizards/updateWizardCard',
      addWizardCardAction: 'wizards/addWizardCard',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    generateMixedArray(desktopImages, mobileImages) {
      const maxLength = Math.max(desktopImages.length, mobileImages.length);
      const result = [];

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < maxLength; i++) {
        if (desktopImages[i]) result.push(desktopImages[i]); // добавляем нечётный элемент
        if (mobileImages[i]) result.push(mobileImages[i]); // добавляем чётный элемент
      }
      return result;
    },
    handleOk(values) {
      const mixedArray = this.generateMixedArray(this.files, this.mobileFiles);
      const newImages = mixedArray.reduce((acc, item) => {
        if (item.file) {
          return [...acc, item.file];
        }
        return acc;
      }, []);

      if (this.isNewCard) {
        const newSection = {
          ...values,
          images: newImages,
          stepId: this.stepId,
          videoUrl: this.videoUrl,
          showFirst: this.showFirst,
        };
        this.addWizardCardAction({
          newSection,
          type: this.productName,
        });
      } else {
        const deleteImages = this.section.images.filter(
          (url) => mixedArray.every((item) => item.url !== url),
        );
        const newSection = {
          ...values,
          images: newImages,
          id: this.section.id,
          videoUrl: this.videoUrl,
          showFirst: this.showFirst,
        };
        this.updateWizardCardAction({ newSection, type: this.productName, deleteImages });
      }
    },
    async loadVideo(info) {
      const {
        file,
      } = info;
      if (/[^/]*/.exec(file.type)[0] === 'video') {
        notificationWithIcon('info', 'The video is being uploaded');
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('folder', 'wizard-badges');
        try {
          const {
            data: {
              data: {
                url: videoUrl,
              },
            },
          } = await apiCall({
            type: 'POST',
            headers: { 'content-type': 'multipart/form-data' },
            url: URLS.fileUpload,
            body: formData,
            isToken: true,
          });
          this.videoUrl = videoUrl;
          notificationWithIcon('success', 'Video uploaded successfully!');
        } catch (err) {
          const {
            response: {
              data: {
                message: serverMessage = '',
              } = {},
            } = {},
            message: axiosMessage,
          } = err || {};
          const message = serverMessage || axiosMessage || '';
          notificationWithIcon('error', message);
        }
      } else {
        notificationWithIcon('error', 'File type is not correct');
      }
    },
  },
};
</script>

<template>
  <a-modal
    :open="show"
    :footer="null"
    @cancel="hideModal"
    :class="b('')"
  >
    <div :class="b('modal')" v-if="section">
      <h1 class="text-2xl font-bold mb-2">{{ title }}</h1>
      <a-switch
        v-if="withToggle"
        :class="b('switch')"
        checked-children="Video"
        un-checked-children="Images"
        :checked="showFirst === 'video'"
        @click="showFirst = showFirst === 'video' ? 'images' : 'video'"
      />
      <video
        v-if="showFirst === 'video' && videoUrl"
        :class="b('video')"
        :src="videoUrl"
        autoPlay
        controls
      ><track kind="captions" /></video>
      <FormKit
        type="form"
        submit-label="Save"
        @submit="handleOk"
      >
        <h2>
          Desktop images
        </h2>
        <UploadImages
          v-if="!withToggle || (withToggle && showFirst === 'images')"
          :is-multiple="true"
          v-model:files="files"
          :initial-images="section.images.filter((_, index) => index % 2 === 0)"
          :maxNumber="mobileFiles.length + 1"
          :showRemoveIcon="files.length >= mobileFiles.length"
        />
        <h2>
          Mobile images
        </h2>
        <UploadImages
          v-if="!withToggle || (withToggle && showFirst === 'images')"
          :is-multiple="true"
          v-model:files="mobileFiles"
          :initial-images="section.images.filter((_, index) => index % 2 !== 0)"
          :maxNumber="files.length"
          :showRemoveIcon="mobileFiles.length >= files.length"
        />
        <a-upload
          v-else
          name="video"
          list-type="text"
          :class="b('video-uploader')"
          :show-upload-list="false"
          :custom-request="loadVideo"
        >
          <a-button
            type="primary"
            ghost
          >
            <UploadOutlined/>
            Upload video
          </a-button>
        </a-upload>
        <FormKit
            type="text"
            name="title"
            label="Title"
            validation="required"
            placeholder="Title"
            :value="!isNewCard ? section.title : ''"
            :class="b('input')"
        />
        <FormKit
            type="text"
            name="mobileTitle"
            label="Mobile title"
            placeholder="Mobile Title"
            :value="!isNewCard ? section.mobileTitle : ''"
            validation="required"
        />
        <FormKit
            type="text"
            name="description"
            label="Description"
            placeholder="Description"
            :value="!isNewCard ? section.description : ''"
        />
        <FormKit
            type="text"
            name="mobileDescription"
            label="Mobile description"
            placeholder="Mobile description"
            :value="!isNewCard ? section.mobileDescription : ''"
        />
        <FormKit
          type="text"
          name="innerDescription"
          label="Inner Description"
          placeholder="Inner Description"
          :value="!isNewCard ? section.innerDescription : ''"
        />
        <FormKit
          type="text"
          name="innerDescriptionMobile"
          label="Mobile Inner description"
          placeholder="Mobile Inner description"
          :value="!isNewCard ? section.innerDescriptionMobile : ''"
        />
        <FormKit
            type="text"
            name="subTitle"
            label="Text"
            placeholder="Text"
            :value="!isNewCard ? section.subTitle : ''"
            validation="required"
        />
        <FormKit
            type="select"
            name="productId"
            label="Product or option"
            placeholder="Please select product or option"
            :value="!isNewCard ? section.productId : null"
            :options="productList"
            validation="required"
        />
        <FormKit
            type="select"
            name="wizardHelpCenterId"
            label="Help center"
            placeholder="Please select help center"
            :value="!isNewCard ? section.wizardHelpCenterId : null"
            :options="cardHelpCenterList"
        />
      </FormKit>
    </div>
  </a-modal>
</template>

<style scoped lang="scss">
.change-wizard-card-modal {
  min-width: 500px;
  width: fit-content;

  &__modal {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  &__switch {
    width: 100px;
  }
  &__video {
    width: auto;
    height: 250px;
  }

  &__video-uploader {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
  }
}
.formkit-outer {
  width: 100%;
}
</style>
